import tree from "../../../../components/tree.vue";
import MonthTime from "./MonthTime/MonthTime.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
    name: "CheckReportForm",
    components: {
        tree,
        MonthTime,
        ChangeTime
    },
    data() {
        return {
            activeName: 'first',
            orgId: '',
        };
    },
    mounted() {

    },
    methods: {
        handleClick(event) {
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.$refs.monthTime.orgId = this.orgId
                    this.$refs.monthTime.getMonthOrderList()
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.changeTime.orgId = this.orgId
                    this.$refs.changeTime.getMonthOrderList()
                })

            }
        },
    },
};
